  import {
      Flex,
      FormControl,
      FormLabel,
      Icon,
      Input as ChakraInput,
      InputGroup,
      InputProps as ChakraInputProps,
      InputRightElement,
      Text,
      Tooltip,
    } from "@chakra-ui/react";
  import {  KeyboardEvent,useState } from "react";
  import { AiOutlineEye, AiOutlineInfoCircle } from "react-icons/ai";

  
  export interface InputProps extends ChakraInputProps {
    infoTooltipLabel?: string;
    infoTooltip?: boolean;
    errors?: any;
    register?: any;
    classInput?: string;
    before?: string;
    after?: string;
    label?: string;
    labelColor?: string;
    ref?: any;
    mask?: string;
    name?: string;
    variant?: string;
    displayLabel?: boolean;
  }
  type Level = "Fraco" | "Medio" | "Forte";
  
  // mapeamento de cores (Chakra tokens)
  const LEVEL_COLOR: Record<Level, string> = {
    Fraco: "red.500",
    Medio: "yellow.500",
    Forte: "green.500",
  };
  
  const PasswordInput = ({
    infoTooltipLabel,
    infoTooltip,
    labelColor,
    label,
    children,
    className,
    classInput,
    ref,
    register,
    errors,
    before,
    after,
    type,
    mask,
    name,
    onBlur,
    displayLabel = true,
    variant = "outline",
    ...rest
  }: InputProps) => {

    const [typeInput,setTypeInput ] = useState(type);
    const [passwordRules, setPasswordRules ] = useState<Level>(null);
  


    function checkPasswordStrength(pw: KeyboardEvent<HTMLInputElement>) {
      const len = pw.currentTarget.value.length;
      const value = pw.currentTarget.value
      const hasLower = /[a-z]/.test(value);
      const hasUpper = /[A-Z]/.test(value);
      const hasDigit = /\d/.test(value);
      const hasSymbol = /[^A-Za-z0-9]/.test(value);
    
      const types = [hasLower, hasUpper, hasDigit, hasSymbol].filter(Boolean).length;
    
      let level: Level;
    
      if (len < 8) {
        level = "Fraco";
      } else if ((len >= 8 && types >= 3) || (len >= 8 && types === 4)) {
        level = "Forte";
      } else if (types >= 2) {
        level = "Medio";
      } else {
        level = null;
      }    
      setPasswordRules(level);
    }
    
    function computePasswordRules(pw: string) {
     return LEVEL_COLOR[passwordRules]
    }

    return (
      <FormControl isInvalid={!!errors?.message}>
        {label && rest?.visibility !== "hidden" && (
          <FormLabel
            w="100%"
            gap="5px"
            display="flex"
            color={labelColor ? labelColor : "gray.400"}
            fontSize="12px"
            visibility={displayLabel ? "visible" : "hidden"}
          >
            {label}
            {infoTooltip && (
              <Tooltip h="100%" placement="top" hasArrow label={infoTooltipLabel}>
                <span>
                  <Icon w=".8rem" color="gray.400" as={AiOutlineInfoCircle} />
                </span>
              </Tooltip>
            )}
          </FormLabel>
        )}
        <Flex justify="center" align="center">
          {before && (
            <Text fontSize="2xl" color="black">
              {before}
            </Text>
          )}
          <InputGroup>
            <ChakraInput
              {...rest}
              {...register}
              className={classInput}
              onKeyDown={checkPasswordStrength}
              type={typeInput}
              name={name}
              variant={variant}
              borderRadius="2px"
            />
            {mask === "percentage" && (
               <InputRightElement  children={<Text>%</Text>} />
            )}

            {type === "password" && (
               <InputRightElement onClick={() => setTypeInput(typeInput === "password" ? "text" : "password")}  children={<Icon as={AiOutlineEye} />} />
            )}
          </InputGroup>
  
          {after && (
            <Text fontSize="2xl" color="gray.400">
              {after}
            </Text>
          )}
        </Flex>
        {passwordRules && name === "password" && (
          <Text fontWeight={700} color={computePasswordRules(passwordRules)} role="alert">
            {passwordRules}
          </Text>
        )}
        {errors && (
          <Text color="danger" role="alert">
            {errors.message}
          </Text>
        )}
      </FormControl>
    );
  };
  
  export { PasswordInput };